import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    ISmarticoVipLevel,
    smarticoService,
} from '../../services';

@Component
export default class SmarticoVipLevel extends Vue {
    @Prop({ type: Boolean, default: false })
    topNavVariant!: boolean;

    level: ISmarticoVipLevel | null = null;

    private unsubscribe?: () => void;

    get progressPercentage(): number {
        return Math.round(this.level?.progress ?? 0);
    }

    created() {
        this.unsubscribe = smarticoService.subscribeToVipLevel((level) => {
            this.level = level;
        });
    }

    destroyed() {
        this.unsubscribe?.();
    }
}
